"use strict";

/*
 * Fenster oeffnen und schliessen - ohne Bootstrap-JavaScript.
 *
 * Am 2026-09-01 eingefuehrt. Bedient genau dieselben Attribute wie vorher, es
 * musste also kein Template angefasst werden:
 *
 *   data-bs-toggle="modal" data-bs-target="#kennung"   oeffnet
 *   data-bs-dismiss="modal"                            schliesst
 *
 * Und es setzt dieselben Klassen, denn das CSS von Bootstrap bleibt:
 * .modal.show, .modal-backdrop.show. Ein eigenes <dialog> haette neues CSS
 * gebraucht.
 *
 * body.modal-open wird mitgesetzt, hat in diesem Bau aber keine Regel - deshalb
 * kommt overflow zusaetzlich direkt an das Element.
 *
 * Fuenf Fenster gibt es im Bestand: userDataModal, userStatusModal,
 * changePasswordModal (alle aus dem Menue), createFeUserContactModal und
 * feUserSelectionModal. Die letzten zwei oeffnet niemand - das war vorher schon
 * so und bleibt so.
 */

/** Wohin der Fokus zurueck soll, wenn das Fenster wieder zugeht. */
var vorherigerFokus = null;

/** Was am <body> stand, bevor wir es angefasst haben. */
var vorherigerBody = null;

function hintergrund() {
    return document.querySelector(".modal-backdrop");
}

function fokussierbares(fenster) {
    return fenster.querySelector(
        'input:not([type="hidden"]):not([disabled]), select, textarea, button, [href], [tabindex]:not([tabindex="-1"])'
    );
}

function oeffnen(fenster) {
    if (!fenster || fenster.classList.contains("show")) {
        return;
    }

    vorherigerFokus = document.activeElement;

    /*
     * Die Breite der Bildlaufleiste als Innenabstand nachschieben, sonst
     * springt das Layout beim Ausschalten des Scrollens um diese Breite.
     */
    var leiste = window.innerWidth - document.documentElement.clientWidth;
    vorherigerBody = {
        overflow: document.body.style.overflow,
        paddingRight: document.body.style.paddingRight
    };
    document.body.style.overflow = "hidden";
    if (leiste > 0) {
        document.body.style.paddingRight = leiste + "px";
    }
    document.body.classList.add("modal-open");

    if (!hintergrund()) {
        var neu = document.createElement("div");
        neu.className = "modal-backdrop fade";
        document.body.appendChild(neu);
        // Erst im naechsten Bild sichtbar schalten, damit das Einblenden greift.
        window.requestAnimationFrame(function () {
            neu.classList.add("show");
        });
    }

    fenster.style.display = "block";
    fenster.removeAttribute("aria-hidden");
    fenster.setAttribute("aria-modal", "true");
    fenster.setAttribute("role", "dialog");

    window.requestAnimationFrame(function () {
        fenster.classList.add("show");
        var ziel = fokussierbares(fenster);
        if (ziel) {
            ziel.focus();
        } else {
            fenster.setAttribute("tabindex", "-1");
            fenster.focus();
        }
    });
}

function schliessen(fenster) {
    if (!fenster || !fenster.classList.contains("show")) {
        return;
    }

    fenster.classList.remove("show");

    var hg = hintergrund();
    if (hg) {
        hg.classList.remove("show");
    }

    /*
     * .modal.fade .modal-dialog hat eine Bewegung von 0,3 s. Erst danach darf
     * display auf none, sonst verschwindet das Fenster ohne Uebergang.
     */
    window.setTimeout(function () {
        fenster.style.display = "";
        fenster.setAttribute("aria-hidden", "true");
        fenster.removeAttribute("aria-modal");

        if (hg && hg.parentNode) {
            hg.parentNode.removeChild(hg);
        }

        document.body.classList.remove("modal-open");
        if (vorherigerBody) {
            document.body.style.overflow = vorherigerBody.overflow;
            document.body.style.paddingRight = vorherigerBody.paddingRight;
            vorherigerBody = null;
        }

        if (vorherigerFokus && typeof vorherigerFokus.focus === "function") {
            vorherigerFokus.focus();
        }
        vorherigerFokus = null;
    }, 300);
}

function offenes() {
    return document.querySelector(".modal.show");
}

/*
 * Ist dieses Element die gerade geoeffnete Lichtbox? Das entscheidet die
 * Adresszeile: sichtbar ist es nur, solange die Kennung im Fragment steht.
 */
function istOffeneLichtbox(el) {
    return Boolean(el.id) && window.location.hash === "#" + el.id;
}

/*
 * Schliessen heisst: das Fragment raeumen, damit :target nicht mehr passt.
 *
 * Ueber location.hash, nicht ueber history.replaceState. Das war mein erster
 * Versuch, weil replaceState keinen Eintrag in den Verlauf schreibt - er
 * funktioniert aber nicht: der Browser bewertet :target danach nicht neu. Im
 * Browser nachgemessen, dieselbe Seite viermal:
 *
 *   location.hash = ''        flex -> none   URL "/#"   Verlauf +1
 *   location.hash = '#'       flex -> none   URL "/#"   Verlauf +1
 *   replaceState, dann hash   flex -> FLEX   URL "/"    Verlauf +0
 *   Klick auf href="#"        flex -> none   URL "/#"   Verlauf +1
 *
 * Der Schliessknopf im Kopf des Fensters ist ein <a href="#"> - er kostet also
 * denselben Verlaufseintrag. Zwei Wege, die gleich schliessen, sollen sich auch
 * gleich verhalten.
 */
function schliesseLichtbox() {
    window.location.hash = "";
}

document.addEventListener("click", function (e) {
    var oeffner = e.target.closest('[data-bs-toggle="modal"][data-bs-target]');
    if (oeffner) {
        e.preventDefault();
        oeffnen(document.querySelector(oeffner.getAttribute("data-bs-target")));
        return;
    }

    var schliesser = e.target.closest('[data-bs-dismiss="modal"]');
    if (schliesser) {
        e.preventDefault();
        schliessen(schliesser.closest(".modal"));
        return;
    }

    /*
     * Klick daneben schliesst. Geprueft wird auf das Fenster selbst: der
     * Bereich um .modal-dialog gehoert zum .modal-Element.
     */
    if (e.target.classList.contains("modal") && e.target.classList.contains("show")) {
        schliessen(e.target);
        return;
    }

    /*
     * Und dasselbe fuer die Lichtbox.
     *
     * Das Anmeldefenster ist kein Bootstrap-Fenster: es ist eine
     * :target-Lichtbox. <a href="#login"> in Nav.html oeffnet sie,
     * <a href="#"> im Kopf schliesst sie, sichtbar wird sie allein durch
     *
     *     .luftwaffe #login:target { display: flex }
     *
     * Deshalb greift der Zweig darueber nicht - .show kommt hier nie vor.
     *
     * Der dunkle Grund ist das Element selbst; #login.modal traegt eine
     * background-color, einen eigenen .modal-backdrop gibt es nicht. Ein Klick
     * auf das Element (und nicht auf .modal-dialog darin) ist also der Klick
     * daneben.
     *
     * Gewuenscht am 2026-09-01.
     */
    if (e.target.classList.contains("lightbox") && istOffeneLichtbox(e.target)) {
        e.preventDefault();
        schliesseLichtbox();
    }
});

document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
        schliessen(offenes());
    }
});

/*
 * Fuer Templates, die selbst ein Fenster oeffnen wollen. Vorher war dafuer
 * window.bootstrap.Modal da.
 */
window.bwFenster = { oeffnen: oeffnen, schliessen: schliessen };
